<app-modules #modulesComponent [modulesURL]="modulesURL" [modulesPerPage]="6" [currentUserIsAdmin]="currentUserIsAdmin"></app-modules>
